import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexModule } from "@vp/shared/directives/flex";
import { MaterialModule } from "@vp/shared/material";
import { ReplaceStringModule } from "@vp/shared/pipes/replace-string";
import { FilterToolbarComponent } from "./filter-toolbar.component";

@NgModule({
  imports: [CommonModule, MaterialModule, ReplaceStringModule, FlexModule],
  declarations: [FilterToolbarComponent],
  exports: [FilterToolbarComponent]
})
export class FilterToolbarModule {}

export interface FilterToolbarItem {
  value: string;
  label: string;
}
